import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { updateDashboardByName } from "../../../../../../Utils/Sockets";
import BMXDatePicker from "../../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import BMXTimePicker from "../../../../../../Components/Inputs/BMXTimePicker/BMXTimePicker";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { eventTypes } from "../../../../../../Utils/GlobalVariables/Crm/CrmTypes";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { NotificationManager } from "react-notifications";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";
const CrmFormEventStepOne = (props) => {
  const {
    values,
    contractor,
    form,
    loadData,
    registryName,
    index,
    updateTableRegistry,
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [eventStatusSelect, setEventStatusSelect] = useState([]);

  const text = `${t("global:crm.alertInformationText")} ${
    props?.values?.eventType?.name || ""
  } ${props?.values?.nextEventDate || ""} ${
    props?.values?.nextEventTime || ""
  } ${contractor?.name || ""} ${props?.values?.representative?.name || ""}`;

  const eventTypeSelect = eventTypes();
  const offerStatusSelect = [
    {
      name: t("global:crm.offerWin"),
      value: "WIN",
    },
    {
      name: t("global:crm.offerLoss"),
      value: "LOSS",
    },
  ];
  const [representativeDecisionTypeSelect] = useState([
    {
      name: t("global:crm.decisionTypeDECISIVE"),
      value: "DECISIVE",
    },
    {
      name: t("global:crm.decisionTypeNON_DECISIVE"),
      value: "NON_DECISIVE",
    },
    {
      name: t("global:crm.decisionTypeINFLUENCE_ON_DECISION"),
      value: "INFLUENCE_ON_DECISION",
    },
    {
      name: t("global:crm.decisionTypeNO_INFORMATION"),
      value: "NO_INFORMATION",
    },
  ]);

  const getRepresentatives = (contractor, values) => {
    const representatives =
      values?.contractor?.representatives || contractor?.representatives || [];
    return representatives.map((el) => ({
      value: el.uuid,
      name: `${el.name || ""} ${el.lastname || ""}`,
    }));
  };

  const getData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByUUID/${searchTerm}`,
      });

      const [contactPayload] = await Promise.all([data]);

      const contact = contactPayload?.payload?.data;

      if (contact) {
        form.change("contractor", contact);
      } else {
        NotificationManager.info("Brak danych dla podanego UUID");
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const eventStatusFetch = GlobalAuthFetch({
        path: "/dictionary/eventStatus/fieldName",
      });
      const [eventStatusPayload] = await Promise.all([eventStatusFetch]);

      setEventStatusSelect(eventStatusPayload?.payload?.data.dictionaryEntries);
    };
    fetchData();
  }, []);

  return (
    <div className="EventFormStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:crm.basicInformation")} />
      <Row>
        <Col xs={4}>
          <Field
            component={BMXSelectField}
            values={eventTypeSelect?.map((el) => ({
              name: el.name,
              value: el.value,
            }))}
            label={`${t("global:crm.eventType")}*`}
            name="eventType"
            data-cy="eventType"
          />
        </Col>

        <Col xs={{ span: 8 }}>
          <Field
            data-cy="representative"
            disabled={!values?.contractor && !contractor}
            component={BMXSelectField}
            values={getRepresentatives(contractor, values)}
            label={`${t("global:analyst.representative")}*`}
            afterIcon="add"
            afterIconSize="13px"
            afterIconClick={() => {
              const contactUuid = values?.contractor?.uuid || contractor?.uuid;

              const updateSingleRegistry = () => {
                updateDashboardByName("contact", contactUuid);
              };

              dispatch(
                show("RepresentativesModal", {
                  loadData: async () => {
                    await getData(values?.contractor?.uuid || contractor?.uuid);
                  },
                  header: t("global:contact.representativeAdd"),
                  updateSingleRegistry,
                  uuid: contactUuid,
                })
              );
            }}
            name="representative"
            renderValue={(el) => `${el.name || ""} ${el.lastname || ""}`}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 5, offset: 4 }}>
          <Field
            component={BMXSelectField}
            values={representativeDecisionTypeSelect?.map((el) => ({
              name: el.name,
              value: el.value,
            }))}
            label={`${t("global:analyst.representativeDecisionType")}*`}
            name="representativeDecisionType"
            data-cy="representativeDecisionType"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:crm.nextEventDate")}*`}
            name="nextEventDate"
          />
        </Col>
        <Col xs={{ span: 2 }} style={{ paddingRight: "15px" }}>
          <Field
            name="nextEventTime"
            component={BMXTimePicker}
            label={t("global:crm.nextEventTime")}
          />
        </Col>
        <Col xs={{ span: 4, offset: 2 }} style={{ paddingRight: "15px" }}>
          <Field
            component={BMXSelectField}
            values={eventStatusSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:crm.eventStatus")}`}
            name="eventStatus"
            data-cy="eventStatus"
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.eventDescription")}`}
            name="eventDescription"
            maxRows={4}
            multiline={true}
            data-cy="eventDescription"
          />
        </Col>
      </Row>
      <Row>
        <BMXSeparator title={t("global:crm.offerInformation")} />
      </Row>
      <Row>
        <Col xs={{ span: 2 }}>
          <Field
            className="mt-1"
            name="offer"
            fieldtype="checkbox"
            type="checkbox"
            component={BMXTextField}
            label={t("global:crm.offer")}
            onClick={(e) => {
              const newValue = e.target.checked;

              if (!newValue) {
                form.change("offerStatus", null);
              }
            }}
          ></Field>
        </Col>
        <Col xs={{ span: 4 }}>
          <Field
            disabled={!values?.offer}
            component={BMXSelectField}
            values={offerStatusSelect?.map((el) => ({
              name: el.name,
              value: el.value,
            }))}
            label={`${t("global:crm.offerStatus")}`}
            name="offerStatus"
            data-cy="offerStatus"
          />
        </Col>
      </Row>
      <Row>
        <BMXSeparator title={t("global:crm.alertInformation")} />
      </Row>
      <Row>
        <Col xs={{ span: 4 }}>
          <BMXButton
            bmxclass="Success"
            onClick={() => {
              dispatch(
                show("AlertModal", {
                  header: t("global:alert.addAlert"),
                  updateTableRegistry: updateTableRegistry,
                  loadData: loadData,
                  pathUuid: props.uuid,
                  initialValues: {
                    index: index,
                    registryName: registryName,
                    text: text,
                  },
                })
              );
            }}
          >
            {t("global:crm.addAlert")}
          </BMXButton>
        </Col>
      </Row>
    </div>
  );
};

export default CrmFormEventStepOne;
